// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-select .circle-span {
  width: 8px;
  height: 8px;
  background: #ffa412;
  border-radius: 50%;
  margin-right: 10px;
}

.icon-img {
  width: 15.64px;
  height: 16.02px;
  margin-right: 10px;
}

.loc-span {
  color: #aeaeae;
  display: flex;
  align-items: center;
}

.loc-span-sel {
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.gray-color {
  color: #aeaeae;
}

.margin-left {
  margin-left: 0.5rem;
}

.search-card {
  background-color: #333333;
  height: 42.8px;
  width: 269px;
  border-radius: 19px;
}

.search-input-div {
  border-radius: 45px;
  border: none;
  padding: 8px;
  padding-block: 2px;
  font-size: 12px;
  width: 100%;
  border: 1px solid rgba(131, 164, 249, 0.53);
}
.search-input-div .search-input {
  width: 80%;
  border: none;
  outline: none;
  background: transparent;
  color: #ffffff;
  font-size: 12px;
}

.go-btn {
  border: none;
  background: transparent;
  color: #ffa412;
  cursor: pointer;
}

@media only screen and (max-width: 793px) {
  .location-select {
    width: 100%;
    margin-left: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/food/common/header/components/location-search/location-search.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAQE;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AALJ;;AAQA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AALF;;AAOA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;AAJF;;AAMA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAKA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAIA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,2CAAA;AADF;AAGE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AADJ;;AAKA;EACE,YAAA;EACA,uBAAA;EACA,cCpDuB;EDqDvB,eAAA;AAFF;;AAaA;EACE;IACA,WAAA;IACA,yBAAA;EAVA;AACF","sourcesContent":["@import \"../../../../../../styles/variables.scss\";\n\n.location-select {\n  // margin-left: 25px !important;\n  // background: #333333;\n  // border-radius: 50px;\n  // border: 1px solid #c4c4c4 !important;\n  // outline: none;\n  .circle-span {\n    width: 8px;\n    height: 8px;\n    background: #ffa412;\n    border-radius: 50%;\n    margin-right: 10px;\n  }\n}\n.icon-img {\n  width: 15.64px;\n  height: 16.02px;\n  margin-right: 10px;\n}\n.loc-span {\n  color: #aeaeae;\n  display: flex;\n  align-items: center;\n}\n.loc-span-sel {\n  color: #fff;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.gray-color {\n  color: #aeaeae;\n}\n\n.margin-left {\n  margin-left: 0.5rem;\n}\n.search-card {\n  background-color: #333333;\n  height: 42.8px;\n  width: 269px;\n  border-radius: 19px;\n}\n.search-input-div {\n  border-radius: 45px;\n  border: none;\n  padding: 8px;\n  padding-block: 2px;\n  font-size: 12px;\n  width: 100%;\n  border: 1px solid rgba(131, 164, 249, 0.53);\n\n  .search-input {\n    width: 80%;\n    border: none;\n    outline: none;\n    background: transparent;\n    color: #ffffff;\n    font-size: 12px;\n  }\n}\n\n.go-btn {\n  border: none;\n  background: transparent;\n  color: $orange-yellowish-color;\n  cursor: pointer;\n}\n// .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon,\n// .css-bpeome-MuiSvgIcon-root-MuiSelect-icon {\n//   color: #fff !important;\n// }\n// .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n//   border: 2px solid #fff !important;\n//   border-color: $secondary-color !important;\n// }\n\n@media only screen and (max-width: 793px) {\n  .location-select {\n  width: 100%;\n  margin-left: 0 !important;\n  }\n}","// all color, text-sizes, border-radius etc  should be initialize here as variables and use them in styling\n// do not write explicitly values.\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n//colors\n$primary-color: #ff611d;\n$secondary-color: #333333;\n\n$black-color: #000000;\n$white-color: #ffffff;\n$dark-gray-color: #3c3c3c;\n$grey-color: #747070;\n$orange-color: #ff8908;\n$yellow-color: #ffb80e;\n$link-color: #59a9ff;\n$orange-yellowish-color: #ffa412;\n$mid-green-color: #00d27a;\n$apple-green-color:#659c35;\n$dark-white-smoke-color: #f5f8fe;\n$mix-grey-color: linear-gradient(180deg, #464c52 0%, #464c5299 100%);\n$orange-color-300: #FFA300;\n\n$solitude-color:#E9EFFD;\n$error-color: #dc3545;\n$alert-text-color:#81222C;\n$success-color: #165c27;\n$alertgreen-color: #d0e7d6;\n$alertred-color:#F7D5D8;\n$selected-tap-color: #1c1b1b;\n$rate-star-color: #ffce31;\n$icon-color: #c4c4c4;\n$selected-field-color: #6c757d;\n$hover-color: #fee6dd;\n$blue_magenta_color: #EBEBEE;\n$green-color:#40d698;\n$light-gray-color:#9d99b9;\n$mid-gray: #676c70;\n\n//font-size\n$primary-heading: 32px;\n$secondary-heading: 24px;\n$tertiary-heading: 28px;\n$heading-48: 48px;\n$heading-42: 42px;\n$heading-20: 20px;\n$heading-22: 22px;\n$heading-18: 18px;\n\n$primary-title: 16px;\n$secondary-title: 14px;\n$tertiary-title: 12px;\n$title-15: 15px;\n$title-13: 13px;\n$title-10: 10px;\n\n//border-radius\n$border-radius-4: 4px;\n$border-radius-5: 5px;\n$border-radius-10: 10px;\n$border-radius-15: 15px;\n$border-radius-20: 20px;\n$border-radius-rounded:50%;\n\n//font-weight\n$font-weight-300: 300;\n$font-weight-400: 400;\n$font-weight-500: 500;\n$font-weight-600: 600;\n$font-weight-700: 700;\n$font-weight-800: 800;\n$font-weight-900: 900;\n\n//font-family\n$font-family-montserrat: \"Montserrat\", \"Roboto\", \"sans-serif\";\n$font-family-roboto: \"Roboto\", \"sans-serif\", \"Montserrat\";"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
